var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cat-icon",
      class: [
        _vm.sizeClass,
        { "cat-icon--clickable": _vm.clickable && !_vm.shouldShowYomisukeIcon },
      ],
      on: { click: _vm.handleClick },
    },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "cat-icon__loading" }, [
            _c("div", { staticClass: "spinner" }),
          ])
        : _c("img", {
            attrs: { src: _vm.computedIconSrc, alt: _vm.computedAltText },
            on: { error: _vm.handleImageError },
          }),
      _vm.showFallback
        ? _c("div", { staticClass: "cat-icon__fallback" }, [_vm._v("🐱")])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }